import Rails from '@rails/ujs';
import * as Turbo from '@hotwired/turbo';
import "foundation-sites";
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'
import '../controllers'

import "chartkick/chart.js"

Rails.start();
Turbo.session.drive = false;
window.Rails = Rails
